export class LanguageMapper {
  private static readonly LANG_MAP: { [key: string]: string } = {
    'en': 'en',
    'en-US': 'en',
    'ru': 'ru',
    'ru-RU': 'ru',
    'uz': 'uz',
    'uz-Latn-UZ': 'uz',
    'ar': 'ar',
    'ar-LB': 'ar',
    'ar-SA': 'ar',
    'fr': 'fr',
    'fr-FR': 'fr',
    'es': 'es',
    'es-MX': 'es',
    'es-BO': 'es',
    'pt': 'pt',
    'pt-BR': 'pt'
  };

  private static readonly CANONICAL_LOCALE: { [key: string]: string } = {
    'en': 'en-US',
    'en-us': 'en-US',
    'ru': 'ru-RU',
    'ru-ru': 'ru-RU',
    'uz': 'uz-Latn-UZ',
    'uz-latn-uz': 'uz-Latn-UZ',
    'ar': 'ar-LB',
    'ar-lb': 'ar-LB',
    'ar-sa': 'ar-SA',
    'fr': 'fr-FR',
    'fr-fr': 'fr-FR',
    'es': 'es-MX',
    'es-mx': 'es-MX',
    'es-bo': 'es-BO',
    'pt': 'pt-BR',
    'pt-br': 'pt-BR'
  };

  static normalize(langCode: string): string {
    if (!langCode) {
      return 'en';
    }
    const exact = this.LANG_MAP[langCode];
    if (exact) {
      return exact;
    }
    const lower = langCode.toLowerCase();
    const matched = Object.keys(this.LANG_MAP).find(key => key.toLowerCase() === lower);
    return matched ? this.LANG_MAP[matched] : 'en';
  }

  /** Prefer BCP-47 codes used in template LocalizedText maps (`ru-RU`, `uz-Latn-UZ`, …). */
  static canonicalize(langCode: string): string {
    if (!langCode) {
      return 'en-US';
    }
    const trimmed = langCode.trim();
    const byKey = this.CANONICAL_LOCALE[trimmed] || this.CANONICAL_LOCALE[trimmed.toLowerCase()];
    if (byKey) {
      return byKey;
    }
    const matched = Object.keys(this.LANG_MAP).find(key => key.toLowerCase() === trimmed.toLowerCase());
    return matched || trimmed;
  }
}
